'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EmbedIframe = require('./EmbedIframe');

var _EmbedIframe2 = _interopRequireDefault(_EmbedIframe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _EmbedIframe2.default;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-embed-content/lib/cjs/EmbedIframe/index.js
 ** module id = 507
 ** module chunks = 1
 **/